import { render, staticRenderFns } from "./single.vue?vue&type=template&id=099d0cc5&scoped=true&"
import script from "./single.vue?vue&type=script&lang=js&"
export * from "./single.vue?vue&type=script&lang=js&"
import style0 from "./single.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./single.vue?vue&type=style&index=1&id=099d0cc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099d0cc5",
  null
  
)

component.options.__file = "single.vue"
export default component.exports